import { BehaviorSubject, Observable, pipe, UnaryFunction } from 'rxjs';
import { debounceTime, filter, map, pairwise, startWith, tap } from 'rxjs/operators';

export const setLoadingState = (
    isSearchingObservable$: BehaviorSubject<boolean>
): UnaryFunction<Observable<string>, Observable<string>> =>
    pipe(
        filter((term: string) => term.length > 1),
        tap(() => isSearchingObservable$.next(true)),
        debounceTime(650),
        startWith(''),
        pairwise(),
        tap(([prev, curr]) => {
            // If search term is the same, set loading to false
            if (prev === curr) {
                isSearchingObservable$.next(false);
            }
        }),
        map(([_, curr]) => curr)
    );
